import { Badge } from '@entur/layout';
import styles from './styles.module.scss';
import { GridContainer, GridItem } from '@entur/grid';

interface InfoIconWrapperProps {
  children: React.ReactNode;
  openDrawer?: () => void;
  showIcon?: boolean;
}

export const InfoIconWrapper = ({ children, openDrawer, showIcon = false }: InfoIconWrapperProps) => (
  <GridContainer spacing="small">
    <GridItem small={12}>
      <div className={styles.field}>
        {children}
        {showIcon && (
          <div className={styles.icon}>
            <Badge variant="info" type="notification" onClick={openDrawer}>
              i
            </Badge>
          </div>
        )}
      </div>
    </GridItem>
  </GridContainer>
);
